import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { distribuidorModulo } from '../../diccionarios/distribuidorModulo';
import { DistribuidorMantenedorModel } from '../../models/distribuidorMantenedorModel';
import { PresupuestoModel, PresupuestoModelInterface } from '../../models/presupuestoModel';
import { CatalogoService } from '../../services/catalogo.service';
import { DistribuidorService } from '../../services/distribuidor.service';

@Component({
  selector: 'app-upload-csv-presupuesto',
  templateUrl: './upload-csv-presupuesto.component.html',
  styleUrls: ['./upload-csv-presupuesto.component.css']
})
export class UploadCsvPresupuestoComponent implements OnInit {

  titulo = 'PRESUPUESTO';
  mostrarFormulario = false;

  textoBuscar = '';
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  frameworkComponents: any;
  rowSelection: any;
  rowData: PresupuestoModel[] = [];

  textoBuscarCli = '';
  gridApiCli: any;
  gridColumnApiCli: any;
  columnDefsCli: any[];
  frameworkComponentsCli: any;
  rowSelectionCli: any;
  rowDataCli: any[] = [];

  @ViewChild('fileInput') fileInput: ElementRef;
  formulario: FormGroup;

  loading: boolean = false;
  listaVacia: boolean = true;
  listaVaciaCli: boolean = true;

  distribuidorModulo: any = {};

  DAT_BTNS: any;
  DAT_MSG: any;
  DAT_BTNCSS: any;

  modelGridPresupuesto: PresupuestoModelInterface;
  csv: string;

  errorData: boolean = true;

  dataPresupuesto: PresupuestoModel = {
    anio: 0,
    clienteDistribuidor: ' ',
    contenedor: ' ',
    descripcion: 'n/a',
    item: '',
    mes: 0,
    numeroSemana: 0,
    presupuestoCaja: '0.0',
    presupuestoImporte: '0.0',
    presupuestoKilo: '0.0',
    correct: false,
    devolverModeloGridPresupuesto() {
      return null
    }
  };

  objSelected: any;
  cmbDistribuidor: DistribuidorMantenedorModel[] = [];
  objModel: any = {
    totalCantCajas: 0,// 6411
    totalImporte: 0,// 81885.49
    totalKilos: 0// 50169.4
  };

  constructor(public fb: FormBuilder,
    private _util: UtilsService,
    private _distribuidor: DistribuidorService,
    private catalogo: CatalogoService,
  ) { }

  ngOnInit() {
    this.formulario = this.fb.group({
      idDistribuidor: ['', [Validators.required]],
      multipart: ['', [Validators.required]],
    });
    const innClase = new PresupuestoModel();
    this.modelGridPresupuesto = innClase.devolverModeloGridPresupuesto();
    // console.log(this.modelGridPresupuesto);
    this.distribuidorModulo = distribuidorModulo;
    this.DAT_BTNS = this.distribuidorModulo.button.buttonsNombre;
    this.DAT_MSG = this.distribuidorModulo.mensajes;
    this.DAT_BTNCSS = this.distribuidorModulo.button.buttonsCss;
    this.cargarIconosFiltros();
    this.cargarGrid();
    this.cargarGridCli();
    this.getDistribuidor();
  }

  cargarGrid() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 120,
        cellRendererParams: {
          onClick: this.callModal.bind(this),
          label: 'Ver',//this.DAT_BTNS.eliminar,//buttons.eliminar,
          colorBoton: 'btn btn-link btn-block'//'btn btn-danger btn btn-block'
        }
      },
      {
        headerName: 'ESTADO',
        sortable: true,
        filter: true,
        width: 200,
        cellStyle: this.changeRowColor.bind(this),
        valueGetter: function(params: any){
          return (params.data.correct === true)?'CORRECTO':'INCORRECTO';
        }
      },
      {
        headerName: 'CLIENTE',
        field: this.modelGridPresupuesto.clienteDistribuidor,
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'ID VENDEDOR',
        field: this.modelGridPresupuesto.idVendedorDistribuidor,
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'ITEM',
        field: this.modelGridPresupuesto.item,
        sortable: true,
        filter: true,
        width: 150
      },
      // {
      //   headerName: 'CONTENEDOR',
      //   field: this.modelGridPresupuesto.contenedor,
      //   sortable: true,
      //   filter: true,
      //   width: 150
      // },
      {
        headerName: 'DESCRIP',
        field: this.modelGridPresupuesto.descripcion,
        sortable: true,
        filter: true,
        width: 220
      },
      {
        headerName: 'AÑO',
        field: this.modelGridPresupuesto.anio,
        sortable: true,
        filter: true,
        width: 140
      },
      {
        headerName: 'MES',
        field: this.modelGridPresupuesto.mes,
        sortable: true,
        filter: true,
        width: 140
      },
      {
        headerName: 'SEMANA',
        field: this.modelGridPresupuesto.numeroSemana,
        sortable: true,
        filter: true,
        width: 140
      },
      {
        headerName: 'PRE.CAJA',
        field: this.modelGridPresupuesto.presupuestoCaja,
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'PRE.IMPORTE',
        field: this.modelGridPresupuesto.presupuestoImporte,
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'PRE.KILO',
        field: this.modelGridPresupuesto.presupuestoKilo,
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'DET.ERROR',
        field: 'error.errorCampo',
        cellStyle: this.changeRowColor.bind(this),
        sortable: true,
        filter: true,
        width: 450
      }
    ];
    this.rowSelection = 'multiple';
  }

  changeRowColor(params) {
    let data = params.data;
    if (data.correct != undefined) {
      if (data.correct === true) {
        return {
          'background-color': 'lightgreen',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      } else {
        return {
          'background-color': '#FFC0CB',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
    }
    return null;
  }

  cargarGridCli() {
    this.frameworkComponentsCli = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefsCli = [
      {
        headerName: 'CLIENTE',
        field: this.modelGridPresupuesto.clienteDistribuidor,
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'ID VENDEDOR',
        field: this.modelGridPresupuesto.idVendedorDistribuidor,
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'ITEM',
        field: this.modelGridPresupuesto.item,
        sortable: true,
        filter: true,
        width: 150
      },
      // {
      //   headerName: 'CONTENEDOR',
      //   field: this.modelGridPresupuesto.contenedor,
      //   sortable: true,
      //   filter: true,
      //   width: 150
      // },
      {
        headerName: 'DESCRIP',
        field: this.modelGridPresupuesto.descripcion,
        sortable: true,
        filter: true,
        width: 220
      },
      {
        headerName: 'AÑO',
        field: this.modelGridPresupuesto.anio,
        sortable: true,
        filter: true,
        width: 140
      },
      {
        headerName: 'MES',
        field: this.modelGridPresupuesto.mes,
        sortable: true,
        filter: true,
        width: 140
      },
      {
        headerName: 'SEMANA',
        field: this.modelGridPresupuesto.numeroSemana,
        sortable: true,
        filter: true,
        width: 140
      },
      {
        headerName: 'PRE.CAJA',
        field: this.modelGridPresupuesto.presupuestoCaja,
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'PRE.IMPORTE',
        field: this.modelGridPresupuesto.presupuestoImporte,
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'PRE.KILO',
        field: this.modelGridPresupuesto.presupuestoKilo,
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 120,
        cellRendererParams: {
          onClick: this.callModal.bind(this),
          label: 'Ver',//this.DAT_BTNS.eliminar,//buttons.eliminar,
          colorBoton: 'btn btn-link btn-block'//'btn btn-danger btn btn-block'
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 120,
        cellRendererParams: {
          onClick: this.eliminarElemento.bind(this),
          label: 'Eliminar',
          colorBoton: 'btn btn-danger btn btn-block'
        }
      },
    ];
    this.rowSelectionCli = 'multiple';
  }



  callModal({ rowData }) {
    this.dataPresupuesto = rowData;
    document.getElementById('abrirModal').click();
  }

  cargarIconosFiltros() {
    this.csv = this.catalogo.catalogoAsesorIcon().csv;
  }

  eliminarElemento({ rowData }) {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea Eliminar el siguiente Presupuesto?',
        text: '',
        action: 'Eliminar',
        funcion: this._distribuidor.deletePresupuesto(rowData),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.regresar();
    }).catch((err) => {
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.mensaje);
    });
  }

  // changeRowColor(params) {
  //   let data = params.data;
  //   if (data.estado != undefined) {
  //     if (data.estado === true) {
  //       return {
  //         'background-color': 'lightgreen',
  //         'color': 'black',
  //         'font-weight': 'bold',
  //         'font-size': '14px'
  //       };
  //     } else {
  //       return {
  //         'background-color': '#FFC0CB',
  //         'color': 'black',
  //         'font-weight': 'bold',
  //         'font-size': '14px'
  //       };
  //     }
  //   }
  // }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReadyCli(params) {
    this.gridApiCli = params.api;
    this.gridColumnApiCli = params.columnApi;
  }

  onQuickFilterChangedCli() {
    this.gridApiCli.setQuickFilter(this.textoBuscarCli);
  }

  onFileSelect(event) {
    let allowedExtensions = /(.csv)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.formulario.get('multipart').setValue('');
        this._util.mensajeErrorVisto('El tipo de archivo no es valido, el tipo de archivo permitido es "CSV" ', true, 9000);
        this.fileInput.nativeElement.value = '';
      } else {
        this.formulario.get('multipart').setValue(file);
      }
    }
  }

  setFormData(data: any): FormData {
    const formData = new FormData();
    // formData.append('multipart', data.multipart);
    formData.append('file', new Blob([data.multipart], { type: 'text/csv' }), 'file');
    return formData;
  }

  enviarFormulario() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea enviar el siguiente archivo?',
        text: '',
        action: 'Enviar',
        funcion: this._distribuidor.postUploadFilePresupuesto(this.setFormData(this.formulario.value), this.formulario.get('idDistribuidor').value),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      // debugger
      this.mostrarFormulario = true;
      this.rowData = res.presupuestos;
      this.objModel = res;
      if (this.rowData.length > 0) {
        this.listaVacia = false;
        this.validarRowData();
      } else {
        this.listaVacia = true;
        this.setDataDefault();
      }
    }).catch((err) => {
      console.log('Error ' + err);
      this.rowData = [];
      this.listaVacia = true;
      this.setDataDefault();
    });
  }

  setDataDefault() {
    this.objModel = {
      totalCantCajas: 0,// 6411
      totalImporte: 0,// 81885.49
      totalKilos: 0// 50169.4
    };
  }

  validarRowData() {
    this.errorData = true;
    this.rowData.forEach (e =>{
      if(!e.correct){
         this.errorData = false; 
      }
    });
  }

  guardar() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea guardar el siguiente listado de presupuesto?',
        text: '',
        action: 'Guardar',
        funcion: this._distribuidor.postSaveFilePresupuesto(this.rowData),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.regresar();
    }).catch((err) => {
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.mensaje, true, 3000);
    });
  }

  obtenerObjetoDistribuidor(event) {
    this.objSelected = event[0];
    if(this.objSelected != undefined) {
      this.formulario.get('idDistribuidor').setValue(this.objSelected.idDistribuidor);
      this.getAllPresupuesto(this.objSelected.idDistribuidor);
    } else {
      this.formulario.get('idDistribuidor').setValue('');
      this.rowDataCli = [];
      this.listaVaciaCli = true;
    }
  }

  getAllPresupuesto(idDistribuidor: string) { 
    this._distribuidor.getAllPresupuesto(idDistribuidor).subscribe((res: PresupuestoModel[])=>{
      this.rowDataCli = res;
      this.listaVaciaCli = this.rowDataCli.length === 0 ? true : false;
    },(err:any)=>{
      this.rowDataCli = [];
      this.listaVaciaCli = true;
      this._util.mensajeErroToast(err.error.mensaje);
    });
  }

  getDistribuidor() {
    this._distribuidor.getDistribuidor().subscribe((res: DistribuidorMantenedorModel[]) => {
      this.cmbDistribuidor = res;
      this.cmbDistribuidor = this.cmbDistribuidor.map((e) => {
        e.descripcion = e.idDistribuidor + ' ' + e.nombreDistribuidor;
        return e;
      });
    }, (err: any) => {
      this.cmbDistribuidor = [];
      console.log(err);
      this._util.mensajeErrorVisto(err.error.mensaje);
    });
  }
  
  regresar() {
    this.mostrarFormulario = false;
    this.rowData = [];
    this.rowDataCli = [];
    this.listaVaciaCli = true;
    this.setDataDefault();
    this.formulario.reset();
  }

}
